import BaseViewModel from "../../Core/BaseViewModel";
import NotificationModel from '../../Models/NotificationModel';

export default class NotificationsViewModel extends BaseViewModel{
  notifications: NotificationModel[]=[];
  current_page: number=1;
  totalPage: number=0;
  loading: boolean = false;
}
